import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {AutofillAddressModel} from '../models/contact/autofill-address.model';

@Injectable({
  providedIn: 'root'
})

/**************************************************************
 * This service retrieves autofill data based on user input.
 * Example: User inputs zipcode and city, state, etc retrieved.
 **************************************************************/
export class AutofillService {

  constructor(private http: HttpClient) {}

  getAddressDataFromInput(input: string): Observable<AutofillAddressModel> {
    return this.http.get<AutofillAddressModel>(`/api/autofill/GetAddressDataFromInput/${input}`);
  }
}
